module.exports = __webpack_public_path__ + "static/about-7cdeb67efc431cb40dede5e5879fab33.jpg";